import React, { useContext } from 'react';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(advancedFormat);

import { IAuctionSummaryProps } from 'src/pages/CatalogPage/components/AuctionSummary/AuctionSummary.i';
import { Button, Typography } from '@riac/design-system';
import { CatalogContext } from 'src/pages/CatalogPage/CatalogPage';

export const AuctionSummary = (props: IAuctionSummaryProps): JSX.Element => {
  const sessions = props.sessions.filter((sess) => sess.value != 'All');
  const {auctionId} = useContext(CatalogContext);

  const previewDate = dayjs(props.auctionStartDate).subtract(1, 'day').format('dddd, MMM Do'); //DayJS Note: Interpreting time in local time is ok since we're only working with days.
  let previewStartTime = '10:00 AM'; // (props.auctionTypeID == 1) ? '10:00 AM' : '9:00 AM';
  let previewEndTime = '6:00 PM';

  const auctionStartTime = dayjs(props.auctionStartTime, 'HH:mm:ss').format('h A'); // DayJS Note: Interpreting time in local time is ok since we're only working with hours.

  if(auctionId === 2094) {
    previewStartTime = '11:00 AM';
    previewEndTime = '4:00 PM';
  }

  return (
    <div className='flex flex-col gap-5'>
      <div>
        <Typography weight='bold' color='text-light' size='lg'>Preview Day</Typography>
        <Typography size='lg'>
          {previewDate}
        </Typography>
        <Typography size='lg'>
          {previewStartTime} - {previewEndTime}
        </Typography>
      </div>
      {sessions.map( (session, index) => {
        return <AuctionSession
          sessionRomanNumeral = {intToRoman(index + 1)}
          dateString = {session.name}
          startTime = {auctionStartTime}
          startingLot = {session.startingLot}
          endingLot = {session.endingLot}
          key = {session.value}
        />;
      })}
      {props.auctionExcerpt && <div className='prose' dangerouslySetInnerHTML = {{ __html: props.auctionExcerpt }}/>}
      <Typography tag='div'>
        <p>Phone: <Button unstyled to="tel:13097971500" className='hover:underline hover:text-text-light active:text-text-lighter'>1-309-797-1500</Button></p>
        <p>Toll-Free: <Button unstyled to="tel:18002388022" className='hover:underline hover:text-text-light active:text-text-lighter'>1-800-238-8022</Button></p>
        <p>Email: <Button variant='link' className='p-0 text-text underline hover:underline hover:text-text-light active:text-text-lighter' to="mailto:info@rockislandauction.com">info@rockislandauction.com</Button></p>
        <p>Rock Island Auction Company - {props.locationCity}</p>
        <p>{props.locationAddress}</p>
        <p>{props.locationCity}, {props.locationState}, {props.locationZip}, USA</p>
      </Typography>
    </div>
  );
};

const AuctionSession = (props) => {
  return (
    <div>
      <Typography weight='bold' size='lg' color='text-light'>SESSION {props.sessionRomanNumeral}</Typography>
      <Typography size='lg'>
        {props.dateString}
      </Typography>
      <Typography size='lg'>
        {props.startTime}
      </Typography>
      <Typography size='lg'>
        Lots {props.startingLot} through {props.endingLot}
      </Typography>
    </div>
  );
};

const intToRoman = (num) => {
  const map = {
    M: 1000,
    CM: 900,
    D: 500,
    CD: 400,
    C: 100,
    XC: 90,
    L: 50,
    XL: 40,
    X: 10,
    IX: 9,
    V: 5,
    IV: 4,
    I: 1,
  };
  let result = '';

  for(const key in map) {
    const repeatCounter = Math.floor(num / map[key]);

    if(repeatCounter !== 0) {
      result += key.repeat(repeatCounter);
    }

    num %= map[key];

    if(num === 0) return result;
  }

  return result;
};
